export const STATUS_DRAFT = 1;
export const STATUS_FINAL_PLAN = 2;
export const STATUS_ADJUSTMENT_DRAFT = 3;
export const STATUS_FINAL_ADJUSTED_PLAN = 4;
